import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  noSensor: {
    textAlign: 'center',
    paddingTop: theme.spacing(2),
  },
}));

export default useStyles;
